import React from 'react';
import firebase from '../../../firebase';

import classes from './CalendarPopUp.module.css';

import Button from '../Button/Button';
import Aux from '../../../hoc/Auxiliary';

const calendarPopUp = ( props ) => {
    let className = classes.Disabled;
    if( props.showEvent ) {
        className = classes.CalendarPopUp;
    }
    if( !props.popUpInformation.group ) {
        const role = ( user => {
            if( user ) return user.role;
            return 'user';
        } )( props.user );

        let resource = null;
        if( props.popUpInformation.resource ) {
            resource = ( <Aux><h4>{props.popUpInformation.resource}</h4> <br /></Aux> )
        }
        let buttons = null;
        if( props.popUpInformation.resourceId !== 0 ) {
            if( props.currentId === props.popUpInformation.madeBy || role === 'admin' ) {
                buttons = (
                    <Aux>
                        <Button clicked={props.removeEvent}>DELETE EVENT</Button>
                    </Aux>
                )
            }
        }
        return (
            <div className={className} style={{ top: props.popUpInformation.location.y, left: props.popUpInformation.location.x }}>
                <i className={"material-icons-outlined"} onClick={props.close}>cancel</i>
                <h3>{props.popUpInformation.title}</h3>
                {resource}
                <h4>Time</h4><span>{props.popUpInformation.time}</span><br />
                {buttons}
            </div>
        );
    } else {
        let imageTag = null;
        if( props.popUpInformation.image ) {
            imageTag = ( <img id={props.popUpInformation.image + 'Image'} className={classes.Image} src={''} alt={'Resource'} /> );
            const storage = firebase.storage();
            const image = storage.ref( props.popUpInformation.image );
            image.getDownloadURL()
                .then( resp => {
                    let item = document.getElementById( props.popUpInformation.image + 'Image' );
                    if( item ) { item.setAttribute( 'src', resp ); }
                } )
        }
        const requiredClass = !props.popUpInformation.requiredClass ? null : ( <Aux><h4>Required Class:</h4><span>{props.popUpInformation.requiredClass}</span></Aux> )
        return (
            <div className={className} style={{ top: props.popUpInformation.location.y, left: props.popUpInformation.location.x }}>
                <i className={"material-icons-outlined"} onClick={props.close}>cancel</i>
                <h3>{props.popUpInformation.title}</h3>
                <h4>{props.popUpInformation.description}</h4><br />
                {requiredClass}
                {imageTag}
            </div>
        );
    }
}

export default calendarPopUp;